import React from 'react';
import { TUTORIAL_ORDER_CLUSTER } from '../../TutorialsContainer';
import TutorialManager, { Step } from '../../TutorialManager';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import style from './OrderClusterTutorial.module.scss';
import { useDashboardUIStore } from '@src/pages/DeliveryDashboard/store/dashboardUIStore';
import PIEText from '@src/shared/components/PIEText';
import { Divider } from 'snacks-design-system';
import { DeliveryDashboardScreens } from '@src/pages/DeliveryDashboard/models/model-enum';
import { useTranslation } from 'react-i18next';
import { IconClose } from '@justeattakeaway/pie-icons-react';

const OrderClusterTutorial = () => {
  const { t } = useTranslation();
  const { isResolutionMobile } = useDeviceDetect();
  const { setBottomSheetForcedSnapHeight, setActiveScreen } = useDashboardUIStore();

  const steps: Array<Step> = [
    {
      targetElementSelector: '[data-qa="map-settings-button"]',
      content: ({ closeTutorial }) => (
        <div
          className={`${style.OrderClusterTutorialContainer} ${
            isResolutionMobile ? style.mobile : style.desktop
          }`}
        >
          <div className={`${style.OrderClusterTutorialContainerHeader}`}>
            <PIEText
              text={t('mapSettings.TUTORIAL_CONTENT')}
              color="var(--xds-color-content-default)"
              size="var(--xds-font-size-14)"
              fontWeight="var(--xds-font-weight-regular)"
            />
            <IconClose
              size="l"
              onClick={() => {
                closeTutorial();
                setActiveScreen(DeliveryDashboardScreens.MAP_SETTINGS_SCREEN);
              }}
            />
          </div>
          <Divider offsetSize={'var(--xds-spacing-b)'} />
          <div
            onClick={() => {
              closeTutorial();
              setActiveScreen(DeliveryDashboardScreens.MAP_SETTINGS_SCREEN);
            }}
            className={style.tutorialCloseButton}
          >
            <PIEText
              text={<span>{t('mapSettings.TUTORIAL_OK_BUTTON')}</span>}
              color="var(--xds-color-content-default)"
              size="var(--xds-font-size-14)"
              fontWeight="var(--xds-font-weight-bold)"
            />
          </div>
        </div>
      ),
      position: isResolutionMobile ? 'top' : 'bottom',
    },
  ];
  return (
    <TutorialManager
      onBeforeStart={() => {
        if (isResolutionMobile) {
          setBottomSheetForcedSnapHeight(84);
          window.requestAnimationFrame(() => {
            setBottomSheetForcedSnapHeight(null);
          });
        }
        setTimeout(() => {
          const element = document.getElementById('step_content');
          if (element) {
            element.style.left = '-225px';
          }
        }, 80);
      }}
      onAfterEnd={() => {}}
      steps={steps}
      useTooltip={false}
      tutorialID={TUTORIAL_ORDER_CLUSTER}
    />
  );
};

export default OrderClusterTutorial;
